/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';

/**
 * 
 * @export
 * @interface PostAccessRequestsMeAccessRuleID201Response
 */
export interface PostAccessRequestsMeAccessRuleID201Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof PostAccessRequestsMeAccessRuleID201Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof PostAccessRequestsMeAccessRuleID201Response
     */
    errors?: Array<APIResponseError>;
}

/**
 * Check if a given object implements the PostAccessRequestsMeAccessRuleID201Response interface.
 */
export function instanceOfPostAccessRequestsMeAccessRuleID201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PostAccessRequestsMeAccessRuleID201ResponseFromJSON(json: any): PostAccessRequestsMeAccessRuleID201Response {
    return PostAccessRequestsMeAccessRuleID201ResponseFromJSONTyped(json, false);
}

export function PostAccessRequestsMeAccessRuleID201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostAccessRequestsMeAccessRuleID201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
    };
}

export function PostAccessRequestsMeAccessRuleID201ResponseToJSON(value?: PostAccessRequestsMeAccessRuleID201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
    };
}

